import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Text } from '@chakra-ui/react';
import * as ProcoreIframeHelpers from '@procore/procore-iframe-helpers';
import PropTypes from 'prop-types';

import PulseLoader from '../../../components/PulseLoader';
import { useProcoreOauthCallback } from '../../../services/integration-service';

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const ProcoreOauthSuccess = props => {
  const query = useQuery();
  const code = query.get('code');
  const companyIds = query.get('company_ids');

  // companyIds format: 'pinsCompanyId.procoreCompanyId'
  // b/c procore callback only allows one additional query param
  const splitIds = companyIds.split('.');
  const pinsCompanyId = splitIds[0];
  const procoreCompanyId = splitIds[1];

  const { data, isLoading } = useProcoreOauthCallback({
    pinsCompanyId,
    procoreCompanyId,
    code,
    options: { retry: false }
  });

  const procoreIframeHelper = ProcoreIframeHelpers.initialize();

  if (isLoading) {
    return (
      <Box>
        <Text>Authenticating...</Text>
        <PulseLoader loading={isLoading} />
      </Box>
    );
  }

  if (data?.procoreAccessToken && data?.pinsAccessToken) {
    procoreIframeHelper.authentication.notifySuccess(data);

    return (
      <div>Success!</div>
    );
  }

  procoreIframeHelper.authentication.notifyFailure({ data });

  return (
    <Box>There was an error authenticating with Procore</Box>
  );
};

ProcoreOauthSuccess.propTypes = {};

export default ProcoreOauthSuccess;
